import { render, staticRenderFns } from "./quizkomunikasi_detail.vue?vue&type=template&id=72fff154&"
import script from "./quizkomunikasi_detail.vue?vue&type=script&lang=js&"
export * from "./quizkomunikasi_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports